export default __webpack_public_path__ + "static/media/sadms_new.122eac30.svg";